module.exports = __webpack_public_path__ + "img/landing-man.0d656c25.png";